import React, { useState, useEffect, useRef } from "react";

const CustomToolbar = ({
  label,
  onNavigate,
  onView,
  views,
  onShowHolidays,
  region,
  groups,
  areasMarked,
  selectedGroupFilter,
  setSelectedGroupFilter,
  selectedPSLCheckboxes,
  setSelectedPSLCheckboxes
}) => {
  const [availablePSLs, setAvailablePSLs] = useState([]);
  const [, setIsPSLDropdownOpen] = useState(false);
  const [isGroupDropdownOpen, setIsGroupDropdownOpen] = useState(false);
  const pslRef = useRef(null);
  const groupRef = useRef(null);

  // Close dropdowns when clicking outside
  useEffect(() => {
  const handleClickOutside = (event) => {
    // ✅ Allow clicks inside PSL dropdown (including checkboxes)
    if (
      pslRef.current &&
      !pslRef.current.contains(event.target) &&
      !event.target.closest(".psl-dropdown")
    ) {
      setIsPSLDropdownOpen(false);
    }
    // ✅ Allow clicks inside Group dropdown
    if (
      groupRef.current &&
      !groupRef.current.contains(event.target) &&
      !event.target.closest(".group-dropdown")
    ) {
      setIsGroupDropdownOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Update PSL list based on selected group
  useEffect(() => {
    if (!areasMarked || !selectedGroupFilter) {
      setAvailablePSLs([]);
      return;
    }
    const groupPSLs = areasMarked
      .filter((area) => {
        const isPSL = area.Name === "PSL - Parking Space Location";
        const belongsToGroup =
          area.groupName === selectedGroupFilter ||
          area.group === selectedGroupFilter ||
          (!area.groupName && selectedGroupFilter === "Default");
        return isPSL && belongsToGroup;
      })
      .map((area) => ({
        id: area.id,
        name: area.pslName || `PSL ${area.id}`,
        groupName: area.groupName || "Default",
      }));

    setAvailablePSLs(groupPSLs);
  }, [selectedGroupFilter, areasMarked]);

  const isAllSelected =
    availablePSLs.length > 0 && selectedPSLCheckboxes.length === availablePSLs.length;
  // Navigation
  const goToBack = () => onNavigate("PREV");
  const goToNext = () => onNavigate("NEXT");
  const goToToday = () => onNavigate("TODAY");

  const holidayButtonText = region === "US" ? "Show U.S. Holidays" : "Show Holidays";

  // Inline message logic (right after PSL button)
  const getInlineMessage = () => {
    if (!selectedGroupFilter && selectedPSLCheckboxes.length === 0) {
    }
    if (!selectedGroupFilter) {
    }
    if (selectedPSLCheckboxes.length === 0) {
    }
    return "";
  };

  const inlineMessage = getInlineMessage();
  const showInlineMessage = inlineMessage.length > 0;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "nowrap",
        gap: "10px",
        padding: "8px 12px",
        backgroundColor: "#fff",
      }}
    >
      {/* LEFT SIDE */}
      <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: 0 }}>
        <span style={{ fontWeight: "700", fontSize: "16px", minWidth: "120px" }}>
          {label}
        </span>

        <button
          onClick={goToToday}
          style={{
            padding: "6px 12px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            background: "#f8f8f8",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          Today
        </button>

        <button
          onClick={onShowHolidays}
          style={{
            padding: "6px 12px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            background: "#f8f8f8",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          {holidayButtonText}
        </button>

        {/* Dropdowns + inline message row */}
        <div style={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0 }}>
          {/* Group dropdown (button style) */}
          <div
            ref={groupRef}
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              whiteSpace: "nowrap"
            }}
          >
            <label style={{ fontWeight: "600", fontSize: "16px" }}>Group Name:</label>

            <button
              onClick={() => setIsGroupDropdownOpen(!isGroupDropdownOpen)}
              style={{
                width: "150px",
                padding: "6px 8px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                fontSize: "13px",
                backgroundColor: "#fff",
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {selectedGroupFilter || "Select"}
              </span>
              <span style={{ transform: isGroupDropdownOpen ? "rotate(180deg)" : "rotate(0)", fontSize: 10 }}>
                ▼
              </span>
            </button>

            {isGroupDropdownOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: "105px",
                  backgroundColor: "#fff",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  marginTop: "2px",
                  boxShadow: "0 4px 8px rgba(70,58,200,0.08)",
                  zIndex: 1000,
                  maxHeight: "220px",
                  overflowY: "auto",
                  width: "150px",
                }}
              >
                {Array.isArray(groups) && groups.length > 0 ? (
                  groups.map((group, index) => {
                    const value = group.name || group.groupName || group || "Default";
                    return (
                      <div
                        key={group.id || index}
                        onClick={() => {
                         setSelectedGroupFilter(value);
                         setSelectedPSLCheckboxes([]);
                         setAvailablePSLs([]);
                         setIsGroupDropdownOpen(false);
                         }}

                        style={{
                          padding: "8px 12px",
                          cursor: "pointer",
                          backgroundColor: selectedGroupFilter === value ? "#e5e7eb" : "#fff",
                          whiteSpace: "nowrap"
                        }}
                      >
                        {value}
                      </div>
                    );
                  })
                ) : (
                  <div style={{ padding: "8px 12px", color: "#777" }}>Default</div>
                )}
              </div>
            )}
          </div>

          {/* Inline validation message (same line, to the right of PSL) */}
          {showInlineMessage && (
            <div
              style={{
                color: "#e63946",
                fontSize: 13,
                fontWeight: 500,
                marginLeft: 8,
                whiteSpace: "nowrap",
                alignSelf: "center",
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              <span style={{ fontSize: 14 }}></span>
              <span>{inlineMessage}</span>
            </div>
          )}
        </div>
      </div>

      {/* RIGHT SIDE (navigation) */}
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <button onClick={goToBack}>‹</button>
        <button onClick={goToNext}>›</button>
        {views.map((viewName) => (
          <button key={viewName} onClick={() => onView(viewName)}>
            {viewName}
          </button>
        ))}
      </div>
    </div>
  );
};
export default CustomToolbar;
